/**
 * A2UI Checkbox Component
 * Checkbox input with label and data binding
 */

import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const A2UICheckbox = ({ 
  label,
  value,
  dataBinding,
  disabled = false,
  action,
  style,
  resolveValue,
  onDataChange,
  onAction,
  surfaceId,
  componentId
}) => {
  const resolvedLabel = resolveValue ? resolveValue(label, surfaceId) : label?.literalString || '';
  const resolvedValue = resolveValue ? resolveValue(value || dataBinding, surfaceId) : false;
  const resolvedDisabled = resolveValue ? resolveValue(disabled, surfaceId) : disabled?.literalBoolean || false;
  
  const [checked, setChecked] = useState(!!resolvedValue);

  useEffect(() => {
    setChecked(!!resolvedValue);
  }, [resolvedValue]);

  const handleChange = (e) => {
    const newValue = e.target.checked;
    setChecked(newValue);
    
    if (dataBinding?.path && onDataChange) {
      onDataChange(surfaceId, dataBinding.path, newValue);
    }

    // Trigger action on change if configured
    if (action && onAction) {
      onAction({
        name: action.name,
        surfaceId,
        sourceComponentId: componentId,
        context: action.context,
        timestamp: new Date().toISOString()
      });
    }
  };

  return (
    <Form.Group className="a2ui-checkbox mb-3" style={style}>
      <Form.Check
        type="checkbox"
        label={resolvedLabel}
        checked={checked}
        onChange={handleChange}
        disabled={resolvedDisabled}
      />
    </Form.Group>
  );
};

export default A2UICheckbox;
